import { Editor, Extensions } from '@tiptap/react';
import Ai, { OnSuccessContext } from '@tiptap-pro/extension-ai';
import AiChanges from '@tiptap-pro/extension-ai-changes';
import { Decoration } from '@tiptap/pm/view';

export interface AIExtensionsOptions {
  token: string;
  onLoading?: () => void;
  onChunk?: (data: { response: string }) => void;
  onSuccess?: (context: OnSuccessContext) => void;
  onError?: (error: Error, context: { editor: Editor }) => void;
}

export function createAIExtensions(options: AIExtensionsOptions): Extensions {
  const { token, onLoading, onChunk, onSuccess, onError } = options;

  return [
    Ai.configure({
      token,
      autocompletion: true,
      onLoading,
      onChunk,
      onSuccess,
      onError,
    }),
    AiChanges.configure({
      getCustomDecorations({ change, isSelected, getDefaultDecorations }) {
        const decorations = getDefaultDecorations();

        if (isSelected) {
          decorations.push(Decoration.widget(change.newRange.to, () => document.createElement('span')));
        }
        return decorations;
      },
    }),
  ];
}
